import { render, staticRenderFns } from "./printer-add-or-update.vue?vue&type=template&id=7e084374&"
import script from "./printer-add-or-update.vue?vue&type=script&lang=js&"
export * from "./printer-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports